module.exports = __webpack_public_path__ + "images/application/pin-55e8cdae.svg";